<template>
<div>
  <div v-show="isConfigEditing === true">
    <el-button type="primary" size="small" @click="saveConfig">저장</el-button>
    <el-button size="small" @click="cancleConfigEdit">취소</el-button>
  </div>
  <div v-show="isConfigEditing === false">
    <el-button  @click="startConfigEdit" type="content" size="small"  class="customised-icon edit"></el-button>
    <!-- <el-button icon="fas fa-edit" size="small" @click="startConfigEdit"></el-button> -->
  </div>
</div>
</template>

<script>
export default {
  name: 'WConfigEditTool',
  computed: {
    /**
     * 구성 현황 정보 편집 활성화 여부
     * @author Ju
     * @return {Boolean} true일 경우 편집 상태 / false일 경우 보기 상태
     */
    isConfigEditing() {
      return this.$store.state.config.isConfigEditing;
    },
  },
  methods: {
    /**
     * 구성 정보 편집 활성화.
     * @author Ju
     * @return {[type]} [description]
     */
    startConfigEdit() {
      this.$store.dispatch('setConfigEditing',true);
    },
    /**
     * 구성 정보 편집 비활성화
     * 수정 정보를 되돌린다
     * @author Ju
     * @return {[type]} [description]
     */
    cancleConfigEdit() {
      this.$store.dispatch('cancleConfigEdit');
    },
    /**
     *  수정 정보를 저장한다
     * @author Hyo
     * @return {[type]} [description]
     */
    saveConfig() {
        this.$store.dispatch('setSaveConfigEditing',true);

      // this.$confirm('저장하시겠습니까?', '저장', {
      //   confirmButtonText: 'OK',
      //   cancelButtonText: 'Cancel',
      //   type: 'warning'
      // }).then(() => {
      //   this.$store.dispatch('setSaveConfigEditing',true);
      // }).catch(() => {
      //
      // });
    }
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/config/components/ConfigEditTool.vue